import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Cacheable } from "ts-cacheable";

import { environment } from "@environments/environment";

import { ParamsService } from "@shared/Services/params.service";

const { enlineaBackendUrl } = environment;

import { Dropdown } from "@RGVSI/Shared/Types/Enums/dropdown.enum";
import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";

import { ReservesFilter } from "../Types/Interfaces/reserves-filter.interface";
import { Reserves, ReservesDetail } from "../Types/Interfaces/reserves.interface";

@Injectable({
  providedIn: "root",
})
export class ReservesRepository {
  constructor(private http: HttpClient, private paramsService: ParamsService) {}

  @Cacheable()
  public getReservesPolicies(): Observable<DropdownOption[]> {
    return this.http.get<DropdownOption[]>(`${enlineaBackendUrl}/api/insurances/Beneficiaries/Policies`);
  }

  public getAccountTypes(): Observable<DropdownOption[]> {
    return this.http.get<DropdownOption[]>(`${enlineaBackendUrl}/api/insurances/Common/Dropdown/${Dropdown.VIPEAccountType}`);
  }

  @Cacheable()
  public getReserves(reservesFilter: ReservesFilter, spinner: boolean): Observable<Reserves> {
    const params = this.paramsService.mapRequestParams(reservesFilter);
    return this.http.get<Reserves>(`${enlineaBackendUrl}/api/insurances/ReserveAccountStatements?spinner=${spinner}`, { params });
  }

  public getReservesDetail(accountCode: string): Observable<ReservesDetail[]> {
    const params = this.paramsService.mapRequestParams({ accountCode });
    return this.http.get<ReservesDetail[]>(`${enlineaBackendUrl}/api/insurances/ReserveAccountStatements/Balances`, { params });
  }

  public getReservesReport(account: string, companyCode: string, startDate: Date, endDate: Date): Observable<Blob> {
    const params = this.paramsService.mapRequestParams({ account, companyCode, startDate, endDate });
    return this.http.get<Blob>(`${enlineaBackendUrl}/api/insurances/ReserveAccountStatements/Report`, {
      params,
      responseType: "blob" as "json",
    });
  }
}
